import mainApi from "./mainApi";


export const saveCotizador = (postdata) => {
  return mainApi.post(`/cotizador`, postdata);
}